define(function(require) {
  const IpsModel = require('civicsBase/ipsModel');

  //This will set an auto generated temporary password
  return IpsModel.extend({
    url: '/delegate/civics-api/api/portal/users/resetpassword',
  });
});
